import type { PlanLevel } from './.client/plans';
import { CLIENT_ORIGIN } from './constants';
import type { SubscriptionInterval } from '~/types/subscription';

export const HELP_CENTER_URL = 'https://support.bolt.new';
export const HELP_CENTER_DOMAINS = 'https://support.bolt.new/cloud/domains';
export const HELP_CENTER_HOSTING = 'https://support.bolt.new/cloud/hosting';
export const HACKATHON_URL = 'https://hackathon.dev';
export const CAREERS_URL = '/careers';
export const BOLT_BLOG_URL = '/blog';
export const BOLT_GALLERY_URL = '/gallery';
export const BOLT_STATUS_URL = 'https://status.bolt.new';
export const TERMS_OF_SERVICE_URL = 'https://stackblitz.com/terms-of-service';
export const PRIVACY_POLICY_URL = 'https://stackblitz.com/privacy-policy';

export const DISCORD = 'https://discord.com/invite/stackblitz';
export const ENTERPRISE = '/enterprise';
export const LINKEDIN = 'https://www.linkedin.com/company/stackblitz';
export const X = 'https://x.com/boltdotnew';
export const REDDIT = 'https://www.reddit.com/r/boltnewbuilders/';
export const YOUTUBE = 'https://www.youtube.com/@BoltDotNew';
export const INSTAGRAM = 'https://www.instagram.com/boltdotnew/';

export const PRICING_URL = '/pricing';

const GITHUB_APP_URL = `${CLIENT_ORIGIN}/github_app`;

export const getGithubConnectAppRoute = ({
  level,
  interval,
  addTeamFlow,
}: {
  level: PlanLevel;
  interval: SubscriptionInterval;
  addTeamFlow?: boolean;
}): string => {
  const url = new URL(GITHUB_APP_URL, location.href);
  const redirectTo = `${window.origin}/?provider=%{provider}&slug=%{slug}&level=${level}&interval=${interval}&showMembersModal=true`;

  if (addTeamFlow) {
    url.searchParams.set('add_team_flow', 'true');
  }

  url.searchParams.set('redirect_to', redirectTo);

  return url.toString();
};
